import { Color, Vector2 } from "three";
import { Maps, useMaterial, useMeshPhysicalMaterial } from "@utils/useMaterial";

/* Textures - Modify as needed */
const maps: Partial<Maps> = {
    map: ["T_StyroFoam_Colored_Light_A.jpg", {
        repeat: new Vector2(10, 10)
    }],
    normalMap: ["T_StyroFoam_N.jpg", {
        repeat: new Vector2(10, 10)
    }]
};

/* Preload textures */
useMaterial.preload(maps);

export default function useMat() {
    /* Create Material - Modify as needed */
    return useMeshPhysicalMaterial(maps, {
        color: new Color("#dae0ff"),
        metalness: 0,
        roughness: 0.814199,
        normalScale: new Vector2(1, 1),
        envMapIntensity: 1,
    });
}